import { render, staticRenderFns } from "./FabricaDetail.vue?vue&type=template&id=8cab34dc&scoped=true"
import script from "./FabricaDetail.vue?vue&type=script&lang=js"
export * from "./FabricaDetail.vue?vue&type=script&lang=js"
import style0 from "./FabricaDetail.vue?vue&type=style&index=0&id=8cab34dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cab34dc",
  null
  
)

export default component.exports